import { SortableItemContainerComponent } from "@/Common/Components/Collections/SortableItemContainer";
import { MedicalItemProblemAndCondition } from "@/Patient/Models/MedicalSummary/MedicalItemProblemAndCondition";

class SortableContainerForProblemsAndContitions extends SortableItemContainerComponent<MedicalItemProblemAndCondition> { }

export { SortableContainerForProblemsAndContitions };
